import React from 'react';
import { Trans } from 'react-i18next';
import { Icon } from 'semantic-ui-react';
import styled from 'styled-components';

import i18n from '@/settings/i18n';

import {
  MEMBERSHIP_HINT_PAGE_JA_1,
  MEMBERSHIP_HINT_PAGE_JA_2,
  MEMBERSHIP_HINT_PAGE_JA_3,
} from '@/settings/pages';

export const MembershipHint: React.FC = () => (
  <Horizontal className="hint membership-hint">
    {i18n.languages[0] === 'ja' && <Icon name="idea" />}
    <div>
      <Trans i18nKey="ui.membership.hint">
        <a
          href={MEMBERSHIP_HINT_PAGE_JA_1}
          rel="noopener noreferrer"
          target="_blank"
        >
          link
        </a>
        <br />
        <a
          href={MEMBERSHIP_HINT_PAGE_JA_2}
          rel="noopener noreferrer"
          target="_blank"
        >
          link
        </a>
        <a
          href={MEMBERSHIP_HINT_PAGE_JA_3}
          rel="noopener noreferrer"
          target="_blank"
        >
          link
        </a>
      </Trans>
    </div>
  </Horizontal>
);

const Horizontal = styled.div`
  &.hint.membership-hint {
    display: flex;
    margin: 0.55em 0 0;
    color: #aaa;
    font-size: 0.9em;
    text-align: left;
  }
`;
